import { render, staticRenderFns } from "./userDoctor.vue?vue&type=template&id=66344bea&scoped=true&"
import script from "./userDoctor.vue?vue&type=script&lang=js&"
export * from "./userDoctor.vue?vue&type=script&lang=js&"
import style0 from "./userDoctor.vue?vue&type=style&index=0&id=66344bea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66344bea",
  null
  
)

export default component.exports